import { Alert, Button, Space } from "antd";

interface AlertBannerProps {
  onUpdateClick: () => void;
}

export const AlertBanner = ({ onUpdateClick }: AlertBannerProps) => (
  <Alert
    showIcon
    message="Update your profile"
    description="If your profile is updated and complete, it helps recruiters find you easily and early."
    type="warning"
    action={
      <Space>
        <Button size="small" danger onClick={onUpdateClick}>
          Update profile
        </Button>
      </Space>
    }
    closable
  />
);